import { Component, Prop, Vue } from 'vue-property-decorator';

import { NOTIFICATION, REWARD_DROP } from '@/constants';
import { TableHeaderColumns, RewardItemDisplayDTO, RewardItemDTO, PrizeDTO } from '@/models';
import { displayPrizeType } from '@/helpers';
import { updateRewardItem } from '@/services';

@Component({})
export default class EditRewardItemDialog extends Vue {
  @Prop() items: RewardItemDisplayDTO[];
  private rewardPeriodId = -1;
  private readonly headerTable: TableHeaderColumns = [
    {
      value: 'id',
      text: 'ID'
    },
    {
      value: 'product',
      text: 'Product'
    },
    {
      value: 'estimatedPrice',
      text: 'Estimated Price (VND)'
    },
    {
      text: 'Cost (Pollens)',
      value: 'cost'
    },
    {
      value: 'quantity',
      text: 'Quantity'
    },
    {
      value: 'maxRedeemPerUser',
      text: 'Max per user'
    }
  ];
  private displayItems: RewardItemDisplayDTO[] = [];
  private rules = {
    required: (value: number) => !!value || 'Required',
    cost: (value: number) => value > 0 || 'Cost must be greater than zero',
    quantity: (value: number) => value >= 0 || 'Quantity must not be negative',
    maxRedeemPerUser: (value: number | string | null) =>
      this.normalizeMaxRedeemPerUser(value) !== -1 || 'Max per user must be greater than zero'
  };
  private imageUrl = process.env.VUE_APP_HIVE_HOME_URL + '/images/';

  get isSaveButtonDisabled(): boolean {
    return (
      this.displayItems[0].quantity < 0 ||
      this.displayItems[0].cost <= 0 ||
      this.normalizeMaxRedeemPerUser(this.displayItems[0].maxRedeemPerUser) === -1
    );
  }

  async onConfirmChange(): Promise<void> {
    const prizeData: PrizeDTO = {
      id: this.items[0].id,
      name: this.items[0].name,
      image: this.items[0].image,
      description: this.items[0].description,
      type: this.items[0].type
    };
    const dataForUpdateRewardItem: RewardItemDTO = {
      id: this.items[0].id,
      prize: prizeData,
      periodRewardId: this.rewardPeriodId,
      cost: this.items[0].cost,
      quantity: this.items[0].quantity,
      redeemCount: this.items[0].redeemCount,
      maxRedeemPerUser: this.toRequestMaxRedeemPerUser(this.items[0].maxRedeemPerUser),
      estimatedPrice: this.items[0].estimatedPrice
    };
    const updateRewardItemResult = await updateRewardItem(dataForUpdateRewardItem);
    if (updateRewardItemResult.data) {
      const data = {
        showing: true,
        type: NOTIFICATION.TYPE.success,
        title: NOTIFICATION.TEXT.editRewardItemSuccess,
        content: [],
        icon: NOTIFICATION.ICON.success,
        multiline: false,
        height: 0
      };
      this.$store.commit('notification/setNotification', data);
      this.$store.commit('rewardPeriod/updateRewardItem', updateRewardItemResult.data);
    } else {
      const data = {
        showing: true,
        type: NOTIFICATION.TYPE.error,
        title: NOTIFICATION.TEXT.editRewardItemFailed,
        content: [],
        icon: NOTIFICATION.ICON.error,
        multiline: false,
        height: 0
      };
      this.$store.commit('notification/setNotification', data);
    }
    this.$emit('onConfirmChanged', true);
  }

  onCancelChange(): void {
    this.$emit('onCancelChanged', true);
  }

  created(): void {
    this.displayItems = this.items;
    this.rewardPeriodId = parseInt(this.$route.params.id);
  }

  onChangePrice(item: RewardItemDisplayDTO): void {
    const idx = REWARD_DROP.VALUE_RANGE.findIndex(number => number * 1000 > item.estimatedPrice);
    const index = idx === 0 ? 0 : idx === -1 ? REWARD_DROP.RATIO.length - 1 : idx - 1;
    item.cost = Math.ceil((item.estimatedPrice * REWARD_DROP.RATIO[index]) / 1000);
  }

  normalizeMaxRedeemPerUser(value: number | string | null | undefined): number | null | -1 {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const normalizedValue = Number(value);
    if (!Number.isInteger(normalizedValue) || normalizedValue <= 0) {
      return -1;
    }
    return normalizedValue;
  }

  toRequestMaxRedeemPerUser(value: number | string | null | undefined): number | null {
    const normalizedValue = this.normalizeMaxRedeemPerUser(value);
    return normalizedValue === -1 ? null : normalizedValue;
  }

  getPrizeType(type: string): string {
    return displayPrizeType(type);
  }

  getImageSource(imgStr: string): string {
    return this.imageUrl + imgStr;
  }
}
